export default __webpack_public_path__ + "static/media/GothamSSm-Bold.a08a35c9.woff";